import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Diz ao app até onde vai a arte escura que esta tela deixa passar sob a navigation bar.
//
// Vale nas superfícies que sangram — o hero do Super Guia, o backdrop da página de empresa, a
// capa da agenda. Ali o efeito de borda do iOS resolve claro quando o aparelho está em light mode
// e vira um lavado branco por cima da arte azul-escura, cortando a tela em duas.
//
// O que o app precisa não é a ALTURA do elemento, e sim onde ele termina no documento: o backdrop
// da página de empresa começa em -80px, então altura e base não coincidem. Com a base, o app
// escurece a barra só enquanto a arte está atrás dela e a devolve ao claro assim que o conteúdo
// claro chega — abaixo da arte essas páginas são claras (#f4f6f9 no Guia, branco na agenda), e um
// trait escuro fixo deixaria título e status bar brancos sobre vidro claro.
//
// Quem não renderiza esta ponte fica com o vidro do sistema. Uma build antiga ignora o elemento.
export default class extends BridgeComponent {
  static component = "nav-dark"

  connect() {
    super.connect()

    this.report = () => this.#report()
    this.report()
    window.addEventListener("resize", this.report)
  }

  disconnect() {
    window.removeEventListener("resize", this.report)
    super.disconnect()
  }

  #report() {
    const selector = this.bridgeElement.bridgeAttribute("selector")
    const art = selector && document.querySelector(selector)
    // Sem a arte não há o que escurecer: a barra fica com o vidro do sistema, que é o certo.
    if (!art) return

    const bottom = Math.round(art.getBoundingClientRect().bottom + window.scrollY)
    this.send("connect", { bottom }, () => {})
  }
}
